let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRGiG")).then(() => parcelRequire('l6kce'));